/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_WhatInputs */

const en_mk_cmp_multica_what = /** @type {(inputs: Mk_Cmp_Multica_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multica is an open-source platform (Apache 2.0 with additional terms) that turns coding agents into team members: agents have profiles, take issues, report back and produce PRs. Execution happens on your own computer or on their cloud runtime; they detect 26 coding tools. Their repository is large and active — around 49k stars when we read it on 6 September 2026.`)
};

const id_mk_cmp_multica_what = /** @type {(inputs: Mk_Cmp_Multica_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multica adalah platform sumber terbuka (Apache 2.0 dengan syarat tambahan) yang menjadikan coding agent sebagai anggota tim: agen punya profil, mengambil issue, melapor, dan menghasilkan PR. Eksekusinya terjadi di komputer Anda sendiri atau di cloud runtime mereka; mereka mendeteksi 26 alat koding. Repositori mereka besar dan aktif — sekitar 49 ribu bintang saat kami membaca pada 6 September 2026.`)
};

/**
* | output |
* | --- |
* | "Multica is an open-source platform (Apache 2.0 with additional terms) that turns coding agents into team members: agents have profiles, take issues, report b..." |
*
* @param {Mk_Cmp_Multica_WhatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_what = /** @type {((inputs?: Mk_Cmp_Multica_WhatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_WhatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_what(inputs)
	return en_mk_cmp_multica_what(inputs)
});